import React, { useState } from "react";
import { usePaginatedQuery } from "react-query";
import {
  EuiBadge,
  EuiBasicTable,
  EuiCallOut,
  EuiFieldSearch,
  EuiSpacer,
} from "@elastic/eui";
import { getReleaseOutlets } from "../../api/appReleases";
import {
  getErrorMessage,
  getOutletStatus,
  RELEASE_QUERY_KEY,
  REFRESH_INTERVAL_MS,
} from "./helpers";

const OutletsTable = ({ release, leadingColumns = [] }) => {
  const [searchText, setSearchText] = useState("");
  const [search, setSearch] = useState("");
  const [pageIndex, setPageIndex] = useState(0);

  const { resolvedData, isFetching, error } = usePaginatedQuery(
    [RELEASE_QUERY_KEY, "outlets", release.id, search, pageIndex],
    () => getReleaseOutlets(release.id, { search, page: pageIndex + 1 }),
    { refetchInterval: REFRESH_INTERVAL_MS, retry: false },
  );

  const applySearch = (value) => {
    setSearch(value.trim());
    setPageIndex(0);
  };

  const columns = [
    ...leadingColumns,
    {
      name: "Outlet",
      render: (outlet) => (
        <span>
          {outlet.name}
          {outlet.restaurant_name ? ` (${outlet.restaurant_name})` : ""}
        </span>
      ),
    },
    {
      field: "app_version",
      name: "Version",
      render: (version) => version || "Unknown",
    },
    {
      name: "Status",
      render: (outlet) => {
        const status = getOutletStatus(outlet, release);
        return <EuiBadge color={status.color}>{status.label}</EuiBadge>;
      },
    },
    {
      field: "stage",
      name: "Picked at stage",
      render: (stage) => (stage ? `${stage}%` : "-"),
    },
    {
      field: "picked_by",
      name: "Picked by",
      render: (pickedBy) => pickedBy || "-",
    },
  ];

  return (
    <>
      <EuiFieldSearch
        fullWidth
        placeholder="Search outlets and press Enter"
        value={searchText}
        onChange={(event) => {
          setSearchText(event.target.value);
          if (!event.target.value) applySearch("");
        }}
        onSearch={applySearch}
        isClearable
      />
      <EuiSpacer size="s" />
      {error ? (
        <>
          <EuiCallOut
            size="s"
            color="danger"
            iconType="alert"
            title={getErrorMessage(error)}
          />
          <EuiSpacer size="s" />
        </>
      ) : null}
      <EuiBasicTable
        items={resolvedData ? resolvedData.outlets : []}
        columns={columns}
        loading={isFetching}
        noItemsMessage="No outlets found"
        pagination={{
          pageIndex,
          pageSize: resolvedData ? resolvedData.perPage || 10 : 10,
          totalItemCount: resolvedData ? resolvedData.total : 0,
          hidePerPageOptions: true,
        }}
        onChange={({ page }) => setPageIndex(page.index)}
      />
    </>
  );
};

export default OutletsTable;
